<!-- List screen (LeaveRequestList.js) -->
<div class="plr-wrap" *ngIf="!selectedItem">
  <div class="plr-page-head">
    <div>
      <h3 class="plr-page-title">{{ 'leaveRequest' | translate }}</h3>
    </div>
    <button type="button" class="plr-apply-btn" (click)="openApplyModal()">
      <i class="ph ph-plus"></i> <span>{{ 'applyLeave' | translate }}</span>
    </button>
  </div>

  <div class="plr-tabs">
    <button type="button" class="plr-tab" [class.active]="activeStatus === 'ALL'" (click)="setStatus('ALL')">
      {{ 'all' | translate }} <span class="plr-tab-count">{{ totalCount }}</span>
    </button>
    <button type="button" class="plr-tab" *ngIf="statusCounts.pending" [class.active]="activeStatus === 'PENDING'" (click)="setStatus('PENDING')">
      {{ 'pending' | translate }} <span class="plr-tab-count">{{ statusCounts.pending }}</span>
    </button>
    <button type="button" class="plr-tab" *ngIf="statusCounts.approved" [class.active]="activeStatus === 'APPROVED'" (click)="setStatus('APPROVED')">
      {{ 'approved' | translate }} <span class="plr-tab-count">{{ statusCounts.approved }}</span>
    </button>
    <button type="button" class="plr-tab" *ngIf="statusCounts.rejected" [class.active]="activeStatus === 'REJECTED'" (click)="setStatus('REJECTED')">
      {{ 'rejected' | translate }} <span class="plr-tab-count">{{ statusCounts.rejected }}</span>
    </button>
    <button type="button" class="plr-tab" *ngIf="statusCounts.cancelled" [class.active]="activeStatus === 'CANCELLED'" (click)="setStatus('CANCELLED')">
      {{ 'cancelled' | translate }} <span class="plr-tab-count">{{ statusCounts.cancelled }}</span>
    </button>
  </div>

  <ng-template #plrRow let-item="item">
    <div class="plr-row" (click)="openDetail(item)">
      <div class="plr-row-datebox" *ngIf="dateBox(item) as db">
        <div class="plr-row-day">{{ db.day }}</div>
        <div class="plr-row-month">{{ db.month }}</div>
        <div class="plr-row-weekday">{{ db.weekday }}</div>
      </div>
      <div class="plr-row-body">
        <div class="plr-row-title">{{ item.leaveTypeName }}</div>
        <div class="plr-row-date" *ngIf="item.startTime && item.endTime">
          {{ dateRangeLabel(item) }} &nbsp;&middot;&nbsp; {{ item.startTime }} - {{ item.endTime }}
        </div>
        <div class="plr-row-date" *ngIf="!(item.startTime && item.endTime)">
          {{ dateRangeLabel(item) }}
        </div>
        <div class="plr-row-reason">{{ item.reason }}</div>
        <div class="plr-row-attachment" *ngIf="item.attachments?.length">
          <i class="ph ph-paperclip"></i> {{ 'attachment' | translate }} <span *ngIf="item.attachments.length > 1">&middot; {{ item.attachments.length }}</span>
        </div>
      </div>
      <div class="plr-row-status">
        <span class="plr-chip" [ngClass]="statusChipClass(item.statusSlug)">{{ item.displayStatus }}</span>
        <span class="plr-date-passed" *ngIf="isDatePassed(item)">
          <i class="ph ph-warning"></i> {{ 'datePassed' | translate }}
        </span>
      </div>
    </div>
  </ng-template>

  <div class="plr-list" *ngIf="!listLoading; else plrLoading">
    <div class="plr-empty" *ngIf="!items.length && !listError">
      <div class="pe-icon"><i class="ph ph-folder-open"></i></div>
      <div class="pe-title">{{ 'dataNotFound' | translate }}</div>
    </div>
    <div class="plr-error" *ngIf="listError">{{ listError }}</div>

    <ng-container *ngIf="activeStatus === 'ALL'; else plrFlatList">
      <ng-container *ngIf="pendingItems.length">
        <div class="plr-section-head">
          {{ 'waitingForApproval' | translate }} <span class="plr-section-count">{{ pendingItems.length }}</span>
        </div>
        <ng-container *ngFor="let item of pendingItems; trackBy: trackByLeaveId">
          <ng-container *ngTemplateOutlet="plrRow; context: { item: item }"></ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngFor="let group of groupedNonPendingItems">
        <div class="plr-section-head plr-section-head-month">{{ group.label }}</div>
        <ng-container *ngFor="let item of group.items; trackBy: trackByLeaveId">
          <ng-container *ngTemplateOutlet="plrRow; context: { item: item }"></ng-container>
        </ng-container>
      </ng-container>
    </ng-container>

    <ng-template #plrFlatList>
      <ng-container *ngFor="let item of items; trackBy: trackByLeaveId">
        <ng-container *ngTemplateOutlet="plrRow; context: { item: item }"></ng-container>
      </ng-container>
    </ng-template>
  </div>

  <ng-template #plrLoading>
    <div class="plr-list">
      <div class="plr-row plr-row-skeleton" *ngFor="let n of [1,2,3,4]"></div>
    </div>
  </ng-template>

  <div class="plr-pagination" *ngIf="!listLoading && items.length && maxPageNumber > 1">
    <button type="button" class="plr-page-btn" [disabled]="currentPage <= 1" (click)="goToPrevPage()">
      <i class="ph ph-caret-left"></i> {{ 'previous' | translate }}
    </button>
    <span class="plr-page-indicator">{{ currentPage }} / {{ maxPageNumber }}</span>
    <button type="button" class="plr-page-btn" [disabled]="currentPage >= maxPageNumber" (click)="goToNextPage()">
      {{ 'next' | translate }} <i class="ph ph-caret-right"></i>
    </button>
  </div>
</div>

<!-- Detail screen (LeaveRequestDetail.js) -->
<div class="plr-detail-wrap" *ngIf="selectedItem as item">
  <header class="plr-detail-header">
    <button type="button" class="plr-detail-back" (click)="closeDetail()"><i class="ph ph-arrow-left"></i></button>
    <div class="plr-detail-header-text">
      <div class="plr-detail-header-title">{{ item.leaveTypeName }}</div>
    </div>
    <span class="plr-chip" [ngClass]="statusChipClass(item.statusSlug)">{{ item.displayStatus }}</span>
  </header>

  <div class="plr-detail-card">
    <p class="plr-detail-reason">{{ item.reason }}</p>

    <div class="plr-date-boxes">
      <div class="plr-date-box">
        <div class="plr-date-box-label">{{ 'startDate' | translate }}</div>
        <div class="plr-date-box-value">{{ formatDate(item.startDate) }}<span *ngIf="item.startTime"> &middot; {{ item.startTime }}</span></div>
      </div>
      <div class="plr-date-box">
        <div class="plr-date-box-label">{{ 'endDate' | translate }}</div>
        <div class="plr-date-box-value">{{ formatDate(item.endDate) }}<span *ngIf="item.endTime"> &middot; {{ item.endTime }}</span></div>
      </div>
    </div>

    <div class="plr-person-row" *ngIf="item.displayStatus === 'Approved' && item.actionedByName">
      <div class="plr-person-avatar">
        <img *ngIf="item.actionedByImage" [src]="item.actionedByImage" alt="" />
        <i class="ph ph-check" *ngIf="!item.actionedByImage"></i>
      </div>
      <div>
        <div class="plr-person-label">{{ 'approvedBy' | translate }}</div>
        <div class="plr-person-name">{{ item.actionedByName }}</div>
      </div>
    </div>

    <div class="plr-person-row" *ngIf="item.displayStatus === 'Rejected' && item.actionedByName">
      <div class="plr-person-avatar">
        <img *ngIf="item.actionedByImage" [src]="item.actionedByImage" alt="" />
        <i class="ph ph-x" *ngIf="!item.actionedByImage"></i>
      </div>
      <div>
        <div class="plr-person-label">{{ 'rejectedBy' | translate }}</div>
        <div class="plr-person-name">{{ item.actionedByName }}</div>
      </div>
    </div>

    <div class="plr-cancelled-info" *ngIf="item.displayStatus === 'Cancelled' && item.cancelledDate">
      {{ 'cancelled' | translate }}: {{ formatDate(item.cancelledDate) }}<span *ngIf="item.cancelledTime"> &middot; {{ item.cancelledTime }}</span>
    </div>

    <div class="plr-remark-box" *ngIf="item.remarks && (item.displayStatus === 'Approved' || item.displayStatus === 'Rejected' || item.displayStatus === 'Cancelled')">
      <div class="plr-remark-label">{{ 'remarks' | translate }}</div>
      <div class="plr-remark-text">{{ item.remarks }}</div>
    </div>

    <ng-container *ngIf="item.attachments?.length">
      <div class="plr-attachments-title">{{ 'attachments' | translate }}</div>
      <div class="plr-attachment-list">
        <button type="button" class="plr-attachment-row" *ngFor="let att of item.attachments; let i = index" (click)="openAttachment(att)">
          <span class="plr-attachment-icon" [class.plr-attachment-icon-image]="isImageAttachment(att)">
            <i class="ph ph-image" *ngIf="isImageAttachment(att)"></i>
            <i class="ph ph-file-pdf" *ngIf="!isImageAttachment(att)"></i>
          </span>
          <span>{{ 'attachment' | translate }} {{ i + 1 }}</span>
        </button>
      </div>
    </ng-container>

    <button type="button" class="plr-cancel-btn" *ngIf="item.displayStatus === 'Pending'" (click)="requestCancel(item)">
      {{ 'cancelLeave' | translate }}
    </button>
  </div>
</div>

<!-- Apply Leave modal -->
<div class="plr-modal-overlay" *ngIf="showApplyModal" (click)="closeApplyModal()">
  <div class="plr-apply-modal" (click)="$event.stopPropagation()">
    <div class="plr-modal-head">
      <h3 class="plr-modal-title">{{ 'applyLeave' | translate }}</h3>
      <button type="button" class="plr-modal-close" (click)="closeApplyModal()"><i class="ph ph-x"></i></button>
    </div>

    <div class="plr-modal-body">
      <label class="plr-field-label">{{ 'leaveType' | translate }}</label>
      <select class="plr-select" [(ngModel)]="selectedLeaveTypeId" [disabled]="leaveTypesLoading">
        <option [ngValue]="null">{{ 'selectLeaveType' | translate }}</option>
        <option *ngFor="let t of leaveTypes" [ngValue]="t.leaveTypeId">{{ t.leaveTypeName }}</option>
      </select>

      <div class="plr-field-row">
        <div>
          <label class="plr-field-label">{{ 'startDate' | translate }}</label>
          <input type="date" class="plr-input" [(ngModel)]="startDate" />
        </div>
        <div>
          <label class="plr-field-label">{{ 'endDate' | translate }}</label>
          <input type="date" class="plr-input" [(ngModel)]="endDate" [min]="startDate" [disabled]="!startDate" />
        </div>
      </div>

      <div class="plr-field-row" *ngIf="selectedLeaveType?.isStartTimeRequired || selectedLeaveType?.isEndTimeRequired">
        <div *ngIf="selectedLeaveType?.isStartTimeRequired">
          <label class="plr-field-label">{{ 'startTime' | translate }}</label>
          <input type="time" class="plr-input" [(ngModel)]="startTime" />
        </div>
        <div *ngIf="selectedLeaveType?.isEndTimeRequired">
          <label class="plr-field-label">{{ 'endTime' | translate }}</label>
          <input type="time" class="plr-input" [(ngModel)]="endTime" />
        </div>
      </div>

      <label class="plr-field-label">{{ 'reason' | translate }}</label>
      <textarea class="plr-textarea" rows="3" [(ngModel)]="applyReason"></textarea>

      <label class="plr-field-label">{{ 'attachments' | translate }}</label>
      <div class="plr-attach-strip">
        <div class="plr-attach-thumb" *ngFor="let f of attachmentFiles; let i = index">
          <i class="ph ph-image" *ngIf="isImageFile(f)"></i>
          <i class="ph ph-file-pdf" *ngIf="!isImageFile(f)"></i>
          <span class="plr-attach-name">{{ f.name }}</span>
          <button type="button" class="plr-attach-remove" (click)="removeAttachment(i)"><i class="ph ph-x"></i></button>
        </div>
        <label class="plr-attach-add" *ngIf="attachmentFiles.length < 3">
          <i class="ph ph-plus"></i>
          <input type="file" accept="image/*,application/pdf" multiple hidden (change)="onAttachmentSelected($event)" />
        </label>
      </div>

      <div class="plr-error-message" *ngIf="applyError">{{ applyError }}</div>
    </div>

    <div class="plr-modal-actions">
      <button type="button" class="plr-btn-secondary" (click)="closeApplyModal()" [disabled]="submitting">{{ 'cancel' | translate }}</button>
      <button type="button" class="plr-btn-primary" (click)="submitLeaveRequest()" [disabled]="submitting">
        {{ (submitting ? 'pleaseWait' : 'submit') | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Cancel confirmation -->
<div class="plr-modal-overlay" *ngIf="cancellingItem" (click)="closeCancelModal()">
  <div class="plr-modal" (click)="$event.stopPropagation()">
    <h3 class="plr-modal-title">{{ 'cancelLeave' | translate }}</h3>
    <label class="plr-field-label">{{ 'reason' | translate }} <span class="plr-required-mark">*</span></label>
    <textarea class="plr-textarea" rows="3" [(ngModel)]="cancelReason" [disabled]="cancelling"></textarea>
    <div class="plr-error-message" *ngIf="cancelError">{{ cancelError }}</div>
    <div class="plr-modal-actions">
      <button type="button" class="plr-btn-secondary" (click)="closeCancelModal()" [disabled]="cancelling">{{ 'close' | translate }}</button>
      <button type="button" class="plr-btn-primary" (click)="confirmCancel()" [disabled]="cancelling">
        {{ (cancelling ? 'pleaseWait' : 'confirm') | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Attachment image preview — small centered window -->
<div class="plr-viewer-overlay" *ngIf="imageViewerUrl" (click)="closeImageViewer()">
  <div class="plr-image-viewer-window" (click)="$event.stopPropagation()">
    <button type="button" class="plr-viewer-close" (click)="closeImageViewer()"><i class="ph ph-x"></i></button>
    <img [src]="imageViewerUrl" class="plr-image-viewer-img" alt="" />
  </div>
</div>

<!-- Attachment PDF preview -->
<div class="plr-viewer-overlay" *ngIf="pdfViewerUrl" (click)="closePdfViewer()">
  <div class="plr-pdf-viewer-window" (click)="$event.stopPropagation()">
    <button type="button" class="plr-viewer-close plr-viewer-close-light" (click)="closePdfViewer()"><i class="ph ph-x"></i></button>
    <iframe [src]="pdfViewerUrl" class="plr-pdf-viewer-frame"></iframe>
  </div>
</div>
